var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"viviendasIndex ml-4 p-4"},[_c('tabs',{attrs:{"tabs":_vm.arrayTabs}}),_c('router-view',{staticClass:"mt-4",on:{"refrescar":_vm.listarIndicadores}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }